import { RootState } from "@src/store";
import {
  getProductPickerProductCount,
  getProductPickerSelectedCount,
} from "@src/store/slices/productPicker";
import { getProductPickerSelectionType } from "@src/store/slices/productPicker/selectors/getProductPickerSelectionType";

export const shouldProductPickerShowSelectAll = (state: RootState) => {
  const type = getProductPickerSelectionType(state);
  const selectedCount = getProductPickerSelectedCount(state);
  const totalCount = getProductPickerProductCount(state);
  if (totalCount === undefined) {
    return false;
  }
  return type === "all" && selectedCount < totalCount;
};
